import { render, staticRenderFns } from "./selectAddress2.vue?vue&type=template&id=6d128cd0&scoped=true"
import script from "./selectAddress2.vue?vue&type=script&lang=js"
export * from "./selectAddress2.vue?vue&type=script&lang=js"
import style0 from "./selectAddress2.vue?vue&type=style&index=0&id=6d128cd0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d128cd0",
  null
  
)

export default component.exports